import { GetterTree } from "vuex"
import { AvailabilityResource, AvailabilitiesState } from "~/store/availabilities/availabilities.types"
import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"
import isEmptyObject from "~/helpers/is-empty-object"

export const getters: GetterTree<AvailabilitiesState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) => {
      if (state.data[id]) {
        return getResource<AvailabilityResource>(state, id, rootGetters, included)
      }
      return null
    }
  },

  resources (state, getters) {
    return Object.values(state.data).map(data =>
      getters.resourceById(data.id, ['room', 'hotel', 'availability_rates']))
  },

  hasResources (state) {
    return !isEmptyObject(state.data)
  }
}


export default getters
